export default "__VITE_ASSET__CIzPJxJy__"